const authCheck = (el, binding, vnode) => {
  if (binding.value && binding.value.status) {
    const list = vnode.context.$store.getters.getCurrentUser.nonAuthorizedPermissions || [];

    if (list.some((value) => value === binding.value.method) || binding.value.rule === false) {
      if (binding.value.status === 'hide') el.style.setProperty('display', 'none', 'important');
      else {
        el.setAttribute('disabled', 'disabled');
        if (el.classList.value.split(' ').includes('multiselect')) el.classList.add('multiselect--disabled');
        if (el.classList.value.split(' ').includes('trumbowyg')) el.classList.add('trumbowyg-disabled');
      }
    } else el.style.display = '';

    if (binding.value.methods && binding.value.methods.length > 0) {
      binding.value.methods = binding.value.methods.filter((item) => !list.includes(item));

      if (binding.value.methods.length === 0) {
        if (binding.value.status === 'hide') el.style.setProperty('display', 'none', 'important');
        else el.setAttribute('disabled', 'disabled');
      } else el.style.display = '';
    }
  }
};

export const authanticate = {
  update: authCheck,
  bind: authCheck,
};
